import { registerPlugin } from '@capacitor/core';
const Keyboard = registerPlugin('Keyboard');
export * from './definitions';
export { Keyboard };
//# sourceMappingURL=index.js.map